import { render, staticRenderFns } from "./Capacity.vue?vue&type=template&id=044f7f61&scoped=true&lang=pug&"
import script from "./Capacity.vue?vue&type=script&lang=ts&"
export * from "./Capacity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f7f61",
  null
  
)

export default component.exports